import { ReactComponent as IconEye } from "@/assets/svgs/Union-eye.svg";
import { assetUrl } from '@/utils/asset-url';
import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import { ReactComponent as IconDateGrey } from "@/assets/svgs/icon-date-grey.svg";
import { ReactComponent as IconSearch } from "@/assets/svgs/icon-search.svg";
import { ReactComponent as IconErrorInfoBusiness } from "@/assets/svgs/my-info-business-error.svg";
import { ReactComponent as IconInfoBusiness } from "@/assets/svgs/my-info-business.svg";
import GIFLoader from "@/assets/svgs/my-info-loader.gif";
import Breadcrumbs from "@/components/Breadcrumbs";
import Button from "@/components/Button";
import CardConfigure from "@/componentsDS/Modal/CardConfigure.jsx";
import Dropdown2 from '@/components/Dropdown2';
import Dropdown from "@/components/Dropdown3";
import Input from '@/components/Input';
import InputSuffixIcon from "@/components/InputSuffixIcon";
import Modal from "@/componentsDS/Modal/Modal.jsx";
import Portal from "@/components/Portal";
import SelectorBox from "@/components/SelectorBox2";
import StepList from '@/components/StepList/index';
import Toast from "@/components/Toast/index.js";
import ToggleSwitch3 from '@/components/ToggleSwitch3/index.js';
import useModal from "@/hooks/use-modal";
import useMyInfo from "@/hooks/use-my-info";
import usePage from "@/hooks/use-page";
import usePersona from "@/hooks/use-personas";
import useStepList from '@/hooks/use-step-list';
import useToast from "@/hooks/use-toast";
import useUseCases from "@/hooks/use-use-cases/index.js";
import { useNavigate, useQuery } from "@/lib/router-dom";
import api from "@/services/api/myenrol.js";
import API_PROFILE from '@/services/api/profile.js';
import rem from "@/utils/rem";
import { validateEmail } from "@/utils/validate-email.js";
import validateMobile from "@/utils/validate-mobile.js";
import validateUEN from "@/utils/validateUEN.js";
import classname from "classnames";
import produce from "immer";
import { orderBy, uniqueId } from 'lodash';
import * as moment from 'moment';
import { forwardRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import ReactDOM from 'react-dom';
import { useForm } from 'react-hook-form';
import { useSelector } from "react-redux";
import AgentPrincipalInformationModal from "../components/AgentPrincipalInformationModal/index.jsx";
import AgentPrincipalTnCModal from "../components/AgentPrincipalTnCModal/index.jsx";
import PersonaInfoModal from "../components/PersonaInfoModal/index.jsx";
import { CompanyExists } from "./company-exists-modal.jsx";
import Stepper from "@/componentsDS/Stepper/Stepper.jsx";

let baseUrl = window.location.origin
if (process.env.NODE_ENV === 'development') {
	baseUrl = process.env.REACT_APP_BASE_URL.substring(0, process.env.REACT_APP_BASE_URL.lastIndexOf("/api/v1"))
}

// Shell-hosted builds serve admin-ui under PUBLIC_URL (e.g. `/admin`); standalone builds leave it
// empty. The MyInfo redirect_uri / callbackUrl must point at the real enrolment path
// (`…/admin/use-cases/enrol/sgtradex` under the unified portal) so CorpPass returns the browser to
// the admin SPA rather than the portal. The authorise redirect_uri and the token-exchange
// callbackUrl must match exactly, so build the value once here and reuse it in all three places.
const enrolPath = `${process.env.PUBLIC_URL || ''}/use-cases/enrol/sgtradex`
const enrolCallbackUrl = `${baseUrl}${enrolPath}`

const AddEnrollPage = (role) => {
	/*=================================================
		General
	/================================================*/
	const useCaseId = JSON.parse(sessionStorage.getItem("useCaseDetails"))
	const personas = JSON.parse(sessionStorage.getItem("personaItems"))

	const pageTitle = "Enroll into SGTraDex";

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [pageTitle],
	});

	const { goTo } = useNavigate();
	const profile = useSelector((state) => state.auth.profile);

	const query = useQuery();
	const authCodeQueryparams = query.get("code");

	const toastType = {
		success: "success",
		error: "error",
	};

	const statuses = {
		approved: "APPROVED",
		rejected: "REJECTED",
		revoked: "REVOKED",
		pending: "PENDING",
	};

	const [searchTerm, setSearchTerm] = useState("");
	const [noOfPersona, setNoOfPersona] = useState(0);
	const [orgId, setOrgId] = useState("");

	const [isLoadingMyInfo, setIsLoadingMyInfo] = useState(false)
	const [loading, setLoading] = useState(false)
	const [
		errorMessage,
		setErrorMessage
	] = useState("");
	const [loadingButton, setLoadingButton] = useState(false)

	/*=================================================
		Agent Principal Enrolment - Info Modal
	/================================================*/
	const { visible: enrolInfoModal, show: showEnrolInfoModal, hide: hideEnrolInfoModal } = useModal()

	/*=================================================
		Agent Principal Enrolment - T&C Modal
	/================================================*/
	const { visible: enrolTncModal, show: showEnrolTncModal, hide: hideEnrolTnCModal } = useModal()
	const [enableAgentPrincipal, setEnableAgentPrincipal] = useState(false)

	function handledEnableAgentPrincipal(checked) {
		if (checked) {
			showEnrolTncModal()
		} else {
			setEnableAgentPrincipal(false)
		}
	}

	async function acceptEnrolTnCModal() {
		setEnableAgentPrincipal(true)
		hideEnrolTnCModal();
	}

	/*=================================================
		Remaining Timing
	/================================================*/
	const [timeLeft, setTimeLeft] = useState();
	const [appointmentsList, setAppointmentsList] = useState([]);

	const [myInfoData, setMyInfoData] = useState({
		authRedirectUrl: "",
		companyAppointment: [],
		companyStatus: [],
		companyTypes: [],
		countryOfIncorp: [],
		nationality: [],
	});

	const [myInfoDataDetails, setmyInfoDataDetails] = useState({
		entity: {},
		person: {}
	});

	const [currentProfile, setCurrentMyInfoProfile] = useState({
		email: "",
		fullName: "",
		mobileNumber: "",
		organization: {}
	})

	const [manualForm, setManualForm] = useState(true);
	const [appointmentIdSelected, setAppointmentIdSelected] = useState("");
	const stateID = uniqueId();
	const [startDate, setStartDate] = useState();

	/*=================================================
		Class
	/================================================*/

	const calendarClass = classname({
		"date_picker__format": true,
		"myenrol__date_picker__format": true
	})

	const calendarClassDeactive = classname({
		"date_picker__format": true,
		"myenrol__date_picker__format": true,
		"disabled": true
	})

	/*=================================================
		My-info
	/================================================*/

	async function getMyInfoData() {
		const [error, result] = await api.getRequest();
		if (error) {
			return addToastMessage(error?.message, toastType.error);
		} else {
			Object.keys(result).forEach((key) => {
				if (key === 'authRedirectUrl') {
					myInfoData[key] = result[key];
				}
				else {
					myInfoData[key] = orderBy(result[key], ["name"], ['asc']);
				}
			});
		}
	}

	async function getEntityData() {
		if (appointmentsList.length === 0) {
			setLoading(true)
			setManualForm(false);
			const params = "authCode=" + authCodeQueryparams + `&callbackUrl=${enrolCallbackUrl}`;
			const [error, result] = await api.getRequestParams(params);
			setLoading(false)
			if (error) {
				// window.location.reload();
				return addToastMessage(error?.message, toastType.error);
			}
			Object.keys(result).forEach((key) => {
				myInfoDataDetails[key] = result[key];
			});
			let appointmentArray = result.entity["appointments"]["appointments-list"];
			setAppointmentsList(appointmentArray.filter(item => (item["person-reference"] && item["person-reference"].idno)));
			fillMyInfoDetails();
			showAppointmentSelection();
		}
	}

	async function fillMyInfoDetails() {
		const basic_profile = myInfoDataDetails.entity["basic-profile"];
		const address = myInfoDataDetails.entity.addresses["addresses-list"][0];
		const addressDetails = address.building.value + " " + address.floor.value + " " + address.block.value + " " + address.street.value + " " + address.country.desc + " " + address.postal.value;
		const organization = {
			name: basic_profile["entity-name"].value,
			uen: basic_profile.uen.value,
			registeredAddress: addressDetails,
			...currentProfile.organization,
		}
		setCurrentMyInfoProfile({ ...currentProfile, fullName: myInfoDataDetails.person.name.value, organization });
		setState({
			...state,
			companyType: basic_profile["company-type"].code ? basic_profile["company-type"].code : basic_profile["business-constitution"].code,
			countryofIncorporation: basic_profile["country-of-incorporation"].code,
			companyStatus: basic_profile["entity-status"].value,
		});
		setStartDate(new Date(basic_profile["registration-date"].value));
		hideAppointmentSelection();
	}

	async function fillMyInfoDetailsAppointment() {
		const item = appointmentsList.find(item => item["person-reference"].idno.value === appointmentIdSelected);
		const organization = {
			...currentProfile.organization,
			appointmentName: (appointmentIdSelected) ? item["person-reference"]["person-name"].value : "",
			appointmentEmail: (appointmentIdSelected && item["corppass-email"]) ? item["corppass-email"].value : "",
			appointmentMobile: (appointmentIdSelected && item["corppass-mobileno"]) ? item["corppass-mobileno"].value : ""
		}
		setState({
			...state,
			appointmentNationality: appointmentIdSelected ? item["person-reference"].nationality.code : '',
			appointmentPosition: appointmentIdSelected ? item.position.code : ''
		});
		setCurrentMyInfoProfile({ ...currentProfile, organization });
		hideAppointmentSelection();
	}

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast();

	const { find: findPersonas, findAndSetCurrentPersona, currentItem: persona, items: personaItems, setItems: setPersonaItems, error: errorPersona } = usePersona();
	const { fetch: findUseCase, currentItem: useCaseItem, setCurrentItem: setUseCaseItem, error: errorUseCase } = useUseCases();
	const { fetch: fetchMyInfo, currentItem: myInfoItem, error: errorMyInfo } = useMyInfo();


	useEffect(() => {
		if (!useCaseId) {
			goTo(`/use-cases`);
		}
	}, [useCaseId])

	useEffect(() => {
		const selectedPersona = personaItems?.filter(
			(persona) => persona.$selected === true
		).length;

		setNoOfPersona(selectedPersona);
	}, [personaItems])

	useEffect(() => {
		const getUseCase = {
			useCaseId: useCaseId
		};

		async function getData() {
			const selectedUseCaseItem = await findUseCase(getUseCase);
			setUseCaseItem(selectedUseCaseItem[0]);

			const personasTemp = await findPersonas(getUseCase);

			// const updatedItem = personasTemp..map(field=> ({...field, $selected: false}))
			let tempArr = personasTemp
			if (personas) {
				goToStep(2);
				tempArr = personasTemp.map(item => personas.includes(item.id) ? { ...item, $selected: true } : item)
			}
			setPersonaItems(tempArr)
			fetchMyInfo()
		}
		getData()

		// if (authCodeQueryparams && authCodeQueryparams !== "") {
		// 	let stateObj = { id: "100" };
		//     window.history.replaceState(stateObj, "Use Case", "/use-cases/enrol/sgtradex");
		// 	getEntityData();
		// }
	}, []);

	useEffect(() => {
		async function getData() {
			window.history.replaceState(null, "", enrolPath);
			getEntityData()
		}
		if (authCodeQueryparams !== null) {
			getData()
		}
	}, [authCodeQueryparams])

	useEffect(() => {
		addToastMessage(errorPersona, toastType.error);
	}, [errorPersona]);

	useEffect(() => {
		addToastMessage(errorUseCase, toastType.error);
	}, [errorUseCase]);

	/*=================================================
		To Be Displayed Persona List
	/================================================*/

	async function handleCheckInfo(item) {
		await findAndSetCurrentPersona({ personaId: item.id, useCaseId: useCaseId })
		showPersonaInfo();
	}

	const handleUpdatePersonaSelect = (item) => {
		const index = personaItems?.findIndex(
			(persona) => persona.id === item.id
		);
		const updatedItems = produce(personaItems, (draft) => {
			draft[index].$selected = !draft[index].$selected;
		});

		setPersonaItems(updatedItems);
	};

	function clearPersonaSelection() {
		const updatedItems = produce(personaItems, (draft) => {
			draft.map((persona) => {
				return (persona.$selected = false);
			});
		});

		setPersonaItems(updatedItems);
	}

	const PersonaList = ({ itemData }) => {

		// const selectedPersona = itemData?.filter(
		// 	(persona) => persona.$selected === true
		// ).length;

		// setNoOfPersona(selectedPersona);

		const list = itemData?.filter((persona) => {
			if (searchTerm === "") {
				return personaItems;
			}
			return persona?.name
				.toLowerCase()
				.includes(searchTerm.toLowerCase());
		})
			.map((persona, index) => {
				return (
					<div
						className="request-enrolment-selectors__col"
						key={index}
					>
						<SelectorBox
							label={persona?.name}
							description={persona?.description}
							submit={() => handleUpdatePersonaSelect(persona)}
							disabled={persona.status === statuses.pending}
							active={persona?.$selected}
							handleCheckInfo={() => handleCheckInfo(persona)}
						/>
					</div>
				);
			});

		return (
			<div className="request-enrolment-selectors__cols">
				{list.length > 0 ? (
					list
				) : (
					<div className="request-enrolment-selectors__col">
						You don't have any persona for this use case.
					</div>
				)}
			</div>
		);
	};

	/*=================================================
		Modals
	/================================================*/

	const {
		visible: visiblePersonaInfo,
		show: showPersonaInfo,
		hide: hidePersonaInfo,
	} = useModal();

	const {
		visible: visibleMyInfoBusiness,
		show: showMyInfoBusiness,
		hide: hideMyInfoBusiness,
	} = useModal();

	const {
		visible: visibleMyInfoErrorBusiness,
		show: showMyInfoErrorBusiness,
		hide: hideMyInfoErrorBusiness,
	} = useModal();

	const {
		visible: visibleConnectingMyInfoBusiness,
		show: showConnectingMyInfoBusiness,
		hide: hideConnectingMyInfoBusiness,
	} = useModal();

	const {
		visible: visibleAppointmentSelection,
		show: showAppointmentSelection,
		hide: hideAppointmentSelection,
	} = useModal();

	/*=================================================
		Step
	/================================================*/
	const stepArr =[
		{stepTitle:'Select Personas'},
		{stepTitle:'Enter Company Information'}
	]
	const steps = [...stepArr];
	const { step, goToStep, prevStep, nextStep } = useStepList(steps)

	const selectedSteps = ["Selected Use Case", "Selected Personas", "Selected Agent Principal Enrolment"];

	const [state, setState] = useState({
		appointmentNationality: "",
		appointmentPosition: "",
		companyType: "",
		countryofIncorporation: "",
		companyStatus: "",
	});

	const handleChange = (value, name) => {
		setState((values) => ({ ...values, [name]: value }));
	};

	const SelectedListDetails = () => {
		const list = selectedSteps.map((item, index) => {
			const stepClass = classname({
				"selected-lists__container": true,
			});

			const final = [];
			for (let persona of personaItems) {
				if (persona.$selected === true) {
					if (final.length > 0) {
						final.push(", ");
					}
					final.push(persona.name);
				}
			}

			if (index === 0) {
				return (
					<div className={stepClass} key={index}>
						<div className="selected-list__heading-item">{item}</div>
						<div className="selected-list__content-text">
							{useCaseItem?.name}
						</div>
					</div>
				)
			} else if (step === 2) {
				if (index === 1) {
					return (
						<div className={stepClass} key={index}>
							<div className="selected-list__heading-item">{item}</div>
							<div className="selected-list__content-text">{final}</div>
						</div>
					)
				} else if (index === 2 && useCaseItem?.isAgentEnabled) {
					return (
						<div className={stepClass} key={index}>
							<div className="selected-list__heading-item">{item}</div>
							<div className="selected-list__content-text">{enableAgentPrincipal ? "Yes" : "No"}</div>
						</div>
					)
				}
			}
		});

		return <div className="selected-lists__display">{list}</div>;
	};

	const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
		<div
			className={manualForm ? calendarClass : calendarClassDeactive}
			onClick={onClick}
			ref={ref}
		>
			{!value && (
				<>
					<IconDateGrey />
					<span className="date_picker__selected-empty_color">
						{"Select date"}
					</span>
				</>
			)}
			{value && <span>{value}</span>}
		</div>
	));

	const AppointmentRadio = () => {
		const list = appointmentsList.map((item, index) => {
			return (
				<form id="select-appointment-form" key={index}>
					<div className="select_appointment_header-list" key={index}>
						<div style={{ width: "10%" }}>
							<input type="radio" id={"appointmentName-" + index} name="appointmentName" value={item["person-reference"].idno.value} checked={item["person-reference"].idno.value === appointmentIdSelected}
								className="appointment-radio_class" onClick={(e) => setAppointmentIdSelected(e.target.value)} onChange={() => { }} data-testid="appointment-radio-selected" />
						</div>
						<div style={{ width: "90%" }}>
							<div className='appointment-sourcesystem__radio' >
								<div className="appointment-label_heading appointment-label_heading_bold">
									{item["person-reference"]["person-name"].value}
								</div>
								<div className="appointment-label_heading">
									{item["person-reference"]["nationality"].desc}
								</div>
							</div>
							<div className='appointment-sourcesystem__radio' >
								<div className="appointment-label_heading">
									{(item["corppass-email"] && item["corppass-email"].value) ? item["corppass-email"].value : 'N/A'}
								</div>
								<div className="appointment-label_heading">
									{(item["corppass-mobileno"] && item["corppass-mobileno"].value) ? item["corppass-mobileno"].value : 'N/A'}
								</div>
							</div>
							<div className='appointment-sourcesystem__radio' >
								<div className="appointment-label_heading">
									{item["position"].desc}
								</div>
							</div>
						</div>
					</div>
				</form>
			)
		});
		return list;
	}

	function getStartedMyInfo() {
		setLoadingButton(true);
		// hideMyInfoBusiness();
		const redirect_uri = myInfoItem?.authRedirectUrl + `&purpose=MyEnrolmentForm&state=${stateID}&redirect_uri=${enrolCallbackUrl}`;
		window.location = redirect_uri;
		// showMyInfoErrorBusiness();
	}

	function tryAgainMyInfo() {
		hideMyInfoErrorBusiness();
		setTimeLeft(6);
		setIsLoadingMyInfo(true);
		showConnectingMyInfoBusiness();
	}

	/*=================================================
		Validations & Forms Reset
	/================================================*/

	function checkProperties(obj) {
		for (let key in obj) {
			if (obj[key] === "") return false;
		}
		return true;
	}

	function resetForm(status) {
		setIsLoadingMyInfo(false);
		setManualForm(status);
		setStartDate(null);

		Object.keys(state).forEach((key) => {
			state[key] = "";
		});

		setCurrentMyInfoProfile({
			email: "",
			fullName: "",
			mobileNumber: "",
			organization: {}
		})

		document.getElementById("update-enrolment-form").reset();
	}

	/*=================================================
		Navigate
	/================================================*/

	function onBack() {
		goTo(`/use-cases/${useCaseId}`)
	}

	function loginMyInfoBusiness() {
		showMyInfoBusiness();
	}

	function closeMyInfoBusiness() {
		hideMyInfoBusiness();
		hideMyInfoErrorBusiness();
	}

	function handleNext() {
		// sessionStorage.removeItem('personaItems')
		// sessionStorage.setItem("personaItems", JSON.stringify(personaItems.map(item=> item.$selected === true ).id));

		const personas = personaItems.filter(item => item.$selected === true).map(item => item.id)
		sessionStorage.setItem("personaItems", JSON.stringify(personas))

		nextStep()
	}

	const { register, handleSubmit, formState: { errors, isValid } } = useForm({
		mode: 'onChange'
	})

	/*=================================================
		Form handling
	/================================================*/
	async function handlerForm(inputs) {

		setLoadingButton(true);
		setLoading(true)
		let final = [];
		const payload = {
			// fullName: inputs.full_name ? inputs.full_name : currentProfile.fullName,
			fullName: profile.firstName + (profile.lastName ? " " + profile.lastName : ''),
			mobile: inputs.mobile_number,
			email: profile.email,
			org: {
				name: inputs.company_name ? inputs.company_name : currentProfile.organization.name,
				uen: inputs.company_registration_no ? inputs.company_registration_no : currentProfile.organization.uen,
				companyType: state.companyType,
				incorporationDate: moment.parseZone(startDate).utc(true).format(),
				countryofIncorporation: state.countryofIncorporation,
				companyStatus: state.companyStatus,
				registeredAddress: inputs.company_registration_address ? inputs.company_registration_address : currentProfile.organization.registeredAddress,
				appointmentName: inputs.appointment_name ? inputs.appointment_name : currentProfile.organization.appointmentName,
				appointmentNationality: state.appointmentNationality,
				appointmentEmail: inputs.appointment_email ? inputs.appointment_email : currentProfile.organization.appointmentEmail,
				appointmentMobile: inputs.appointment_number ? inputs.appointment_number : currentProfile.organization.appointmentMobile,
				appointmentPosition: state.appointmentPosition,
				enrolmentDataSource: manualForm ? "MANUAL" : "MYINFO",
				appointmentIdNumber: appointmentIdSelected ? appointmentIdSelected : ""
			},
			isAgent: enableAgentPrincipal
		}
		for (let persona of personaItems) {
			if (persona.$selected === true) {
				final.push(persona.id);
			}
		}
		const body = {
			useCaseId: useCaseId,
			personaIds: final,
			...payload
		};

		const [error, result] = await api.postRequestParams(body);

		if (error) {
			setLoadingButton(false);
			setLoading(false)
			return addToastMessage(error?.message, toastType.error);
		}

		sessionStorage.removeItem('useCaseDetails')
		sessionStorage.removeItem('personaItems')
		const [errorProfile, responseProfile] = await API_PROFILE.index()
		sessionStorage.setItem('profile', JSON.stringify(responseProfile))
		setLoadingButton(false);
		setLoading(false)
		goTo(`/use-cases/${useCaseId}/enroll/success`, {
			from: "addEnrol",
		});
	}

	const handleKeyPress = (event) => {
		const indexOfPlus = event.target.value.indexOf("+");
		if (!/[0-9+]/.test(event.key)) {
			event.preventDefault();
		}
		if (event.target.value.indexOf(" ") >= 0 || indexOfPlus > 0) {
			event.preventDefault();
		}
	}

	return (
		<>
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
				</div>
				<div className="title-header__right"></div>
			</div>

			<Stepper steps={steps} currentStep={step-1}/>

			<SelectedListDetails />

			<div style={{ marginTop: rem(10) }}></div>

			{step === 1 && (
				<>
					<div className="layout-enroll">
						<div className="layout-enroll__content">
							<div className="view-info--details">
								<div className="view-info--selector-box-wrap">

									<div className="request-enrolment-toggle__cols">
										<div className="layout-default__desc__data__element">
											Choose personas that best describe your company's profile{" "}
										</div>

										{useCaseItem?.isAgentEnabled && (
											<div className="layout-enrolment__toggle__content">
												<div className="layout-enrolment__info" onClick={() => { showEnrolInfoModal() }} data-testid="agent-principal-info" >
													<IconEye />
												</div>
												<div>Enable Agent Principal Enrolment:</div>
												<ToggleSwitch3
													id="enableAgentPrincipal"
													checked={enableAgentPrincipal}
													onChange={handledEnableAgentPrincipal}
													data-testid="enable-external-participant-toggle"
												/>
												<div>{enableAgentPrincipal ? "Yes" : "No"}</div>
											</div>
										)}
									</div>

									<div className="request-enrolment__search-box">
										<InputSuffixIcon
											maxWidth="310"
											placeholder="Search"
											icon={<IconSearch />}
											//defaultValue = {search || ""}
											onChange={(e) => {
												setSearchTerm(e.target.value);
											}}
										/>
										<div className="request-enrolment__search-box__selection">
											{noOfPersona} Selected
										</div>
										<Button
											text="Reset Selection"
											noborder
											addClass={
												"request-enrolment__search-box__clear-selection"
											}
											submit={() =>
												clearPersonaSelection()
											}
										/>
									</div>

									<PersonaList itemData={personaItems || []} />
								</div>
							</div>
						</div>
					</div>
				</>
			)}

			{step === 2 && (
				<>
					<div className="layout-enroll">
						<div className="view-info--details">
							{manualForm && (
								<div className="view-info--selector-box-wrap">
									<div className="enrolment-form__info-heading">
										Automatically fill in my information
									</div>
									<div className="enrolment-form__info-button">
										<Button
											text="Login to Myinfo business"
											submit={() => loginMyInfoBusiness()}
										/>
									</div>
								</div>
							)}
							{!manualForm && (
								<div className="myinfo-business__box-wrap">
									<div className="myinfo-business__left-box__wrap">
										<div className="myinfo-business__content-image">
											<IconInfoBusiness />
										</div>
										<div className="myinfo-business__content-text">
											Verified information received for{" "}
											<span className="myinfo-business__selected-name">
												{currentProfile?.fullName}
											</span>
										</div>
									</div>
									<div className="myinfo-business__right-box__wrap myinfo-business__selected-name">
										<span
											className="my-info__manual-fill-text"
											onClick={() => resetForm(true)}
											data-testid="reset-my-info"
										>
											Fill in manually instead
										</span>
									</div>
								</div>
							)}
							{manualForm && (
								<div className="enrolment-form__info-flex">
									<hr />
									<h3 className="enrolment-form__padding">
										OR
									</h3>
									<hr />
								</div>
							)}
							{!manualForm && <hr />}
							<div className="enrolment-form__mandatory-header"><p><b>Note : </b>All fields are mandatory.</p></div>
							<form id="update-enrolment-form" onSubmit={handleSubmit(data => handlerForm(data))}>
								<div className="view-info--selector-box-wrap">
									<div className="my-enrol__heading">
										Personal Information
									</div>
									<div className="my-enrol__layout-flex">
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Full Name
											</div>
											<div>
												<Input
													name="full_name"
													placeholder="Enter name"
													register={register({ required: true })}
													error={errors.full_name}
													errorMessage={errors.full_name?.message}
													defaultValue={profile?.firstName + " " + (profile?.lastName ? profile?.lastName : '')}
													// disabled={!manualForm}
													disabled={true}
													onBlur={(e) => e.target.value = e.target.value.trim()}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Email Address
											</div>
											<div>
												<Input
													name="email_address"
													placeholder="Enter email"
													register={register({ required: true, validate: validateEmail })}
													error={errors.email_address}
													errorMessage={errors.email_address?.message}
													defaultValue={profile?.email}
													disabled={true}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Mobile Number
											</div>
											<div>
												<Input
													name="mobile_number"
													placeholder="Enter number"
													register={register({
														required: true,
														minLength: {
															value: 6,
															message: "Please enter valid mobile number ranging between 6-15 digits"
														},
														maxLength: {
															value: 15,
															message: "Please enter valid mobile number ranging between 6-15 digits"
														},
														validate: {
															checkMobileNumber: v => validateMobile(v) || "Please enter a valid Number"
														}
													})}
													error={errors.mobile_number}
													errorMessage={errors.mobile_number?.message}
													defaultValue={profile?.mobileNumber}
													onBlur={(e) => e.target.value = e.target.value.trim()}
													onKeyPress={(e) => handleKeyPress(e)}
												/>
											</div>
										</div>
									</div>

									<hr />

									<div className="my-enrol__heading">
										Company Information
									</div>
									<div className="my-enrol__layout-flex">
										<div className="my-enrol__container">
											<div className="my-enrol__field-head my-enrol__field-head-flex">
												<div>Registered Company Name</div>
												<div className="my-enrol__field-head__height my-enrol__field-icon" data-tooltip="The company/business name is the legal name of the entity"><IconEye /></div>
											</div>
											<div>
												<Input
													name="company_name"
													placeholder="Enter company name"
													onBlur={(e) => e.target.value = e.target.value.trim()}
													register={register({
														required: true,
														minLength: {
															value: 3,
															message: "Please enter a valid Company Name"
														}
													})}
													error={errors.company_name}
													errorMessage={errors.company_name?.message}
													defaultValue={currentProfile?.organization?.name}
													disabled={!manualForm}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Country of Incorporation
											</div>
											<div className="select">
												<Dropdown2 full
													text={"Select"}
													value={myInfoItem?.countryOfIncorp.find(item => item.value === state.countryofIncorporation)?.name}
													disabled={!manualForm}
													options={myInfoItem?.countryOfIncorp}
													submit={(data) => handleChange(data, "countryofIncorporation")}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head my-enrol__field-head-flex">
												<div>Company Type</div>
												<div className="my-enrol__field-head__height my-enrol__field-icon" data-tooltip="Company type describes the current company classification"><IconEye /></div>
											</div>
											<div className="select">
												<div>
													<Dropdown full
														text={"Select"}
														value={myInfoItem?.companyTypes.find(item => item.value === state.companyType)?.name}
														options={myInfoItem?.companyTypes}
														disabled={!manualForm}
														submit={(data) => handleChange(data, "companyType")}
													/>
												</div>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Date of Incorporation
											</div>
											<div>
												<DatePicker
													selected={startDate}
													onChange={(date) => setStartDate(date)}
													id={"date_of_incorporation"}
													dateFormat="yyyy-MM-dd"
													isClearable={manualForm ? (startDate ? true : false) : false}
													readOnly={!manualForm}
													showMonthDropdown
													showYearDropdown
													dropdownMode="select"
													customInput={<CustomDateInput />}
													maxDate={new Date()}
												/>
											</div>
										</div>
									</div>
									<div className="my-enrol__layout-flex">
										<div className="my-enrol__container">
											<div className="my-enrol__field-head my-enrol__field-head-flex">
												<div>Company Registration No. / UEN</div>
												<div className="my-enrol__field-head__height my-enrol__field-icon" data-tooltip="A registration number that is issued to the entity by the relevant authority in its place of incorporation"><IconEye /></div>
											</div>
											<div>
												<Input
													name="company_registration_no"
													placeholder="Type here"
													register={register({
														required: true,
														validate: {
															checkUEN: v => validateUEN(v, myInfoItem?.countryOfIncorp.find(item => item.value === state.countryofIncorporation)?.value) || "Please enter a valid UEN"
														}
													})}
													error={errors.company_registration_no}
													errorMessage={errors.company_registration_no?.message}
													defaultValue={currentProfile?.organization?.uen}
													disabled={!manualForm}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head my-enrol__field-head-flex">
												<div>Company Status</div>
												<div className="my-enrol__field-head__height my-enrol__field-icon" data-tooltip="Indicates whether the company is currently operational or has ceased operations"><IconEye /></div>
											</div>
											<div className="select">
												<Dropdown full
													text={"Select"}
													value={myInfoItem?.companyStatus.find(item => item.value === state.companyStatus)?.name}
													disabled={!manualForm}
													options={myInfoItem?.companyStatus}
													submit={(data) => handleChange(data, "companyStatus")}
												/>
											</div>
										</div>
										<div className="my-enrol__container-large">
											<div className="my-enrol__field-head">
												Company Registered Address
											</div>
											<div>
												<Input
													name="company_registration_address"
													placeholder="Type here"
													register={register({ required: true })}
													error={errors.company_registration_address}
													errorMessage={errors.company_registration_address?.message}
													defaultValue={currentProfile?.organization?.registeredAddress}
													disabled={!manualForm}
													onBlur={(e) => e.target.value = e.target.value.trim()}
												/>
											</div>
										</div>
									</div>

									<hr />

									<div className="appointment-heading">
										<div className="my-enrol__heading">
											Authorized Signatory
											<span className="my-enrol__heading-details__text">(Details of the individual who will be signing the Data Sharing Agreement (DSA) with SGTraDex) </span>
										</div>
										{!manualForm && <div className="appointment__heading" onClick={() => showAppointmentSelection()} data-testid="appointment-selection-handler">
											&nbsp; (Change)
										</div>}
									</div>
									<div className="my-enrol__layout-flex">
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Name
											</div>
											<div>
												<Input
													name="appointment_name"
													placeholder="Enter name"
													register={register({ required: true })}
													error={errors.appointment_name}
													errorMessage={errors.appointment_name?.message}
													defaultValue={currentProfile?.organization?.appointmentName}
													disabled={!manualForm}
													onBlur={(e) => e.target.value = e.target.value.trim()}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Nationality
											</div>
											<div className="select">
												<Dropdown2 full
													text={"Select"}
													value={myInfoItem?.nationality?.find(item => item.value === state.appointmentNationality)?.name}
													options={myInfoItem?.nationality}
													disabled={!manualForm}
													submit={(data) => handleChange(data, "appointmentNationality")}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Email Address
											</div>
											<div>
												<Input
													name="appointment_email"
													placeholder="Enter email"
													register={register({
														required: true,
														validate: {
															checkEmail: v => validateEmail(v) || "Please enter a valid Email Address"
														}
													})}
													error={errors.appointment_email}
													errorMessage={errors.appointment_email?.message}
													defaultValue={currentProfile?.organization?.appointmentEmail}
													disabled={!manualForm && currentProfile?.organization?.appointmentEmail !== ''}
													onBlur={(e) => e.target.value = e.target.value.trim()}
												/>
											</div>
										</div>
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Mobile Number
											</div>
											<div>
												<Input
													name="appointment_number"
													placeholder="Enter number"
													register={register({
														required: true,
														validate: {
															checkMobileNumber: v => validateMobile(v) || "Please enter a valid Number"
														}
													})}
													error={errors.appointment_number}
													errorMessage={errors.appointment_number?.message}
													defaultValue={currentProfile?.organization?.appointmentMobile}
													disabled={!manualForm && currentProfile?.organization?.appointmentMobile !== ''}
													onBlur={(e) => e.target.value = e.target.value.trim()}
													onKeyPress={(e) => handleKeyPress(e)}
												/>
											</div>
										</div>
									</div>
									<div className="my-enrol__layout-flex">
										<div className="my-enrol__container">
											<div className="my-enrol__field-head">
												Designation
											</div>
											<div className="select">
												<Dropdown full
													text={"Select"}
													value={myInfoItem?.companyAppointment.find(item => item.value === state.appointmentPosition)?.name}
													disabled={!manualForm}
													options={myInfoItem?.companyAppointment}
													submit={(data) => handleChange(data, "appointmentPosition")}
												/>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</>
			)}
			<div className='DS__layout__footer'>

				<div className="layout-default__sticky-actions">
					<div className="layout-default__sticky-actions__left">
						<Button text="Cancel" noborder submit={() => onBack()} />
					</div>
					<div className="layout-default__sticky-actions__right layout-default--flex">
						<div className="layout-default--margin-right">
							{step > 1 && (
								<Button
									text="Previous"
									ghost
									submit={() => prevStep()}
								/>
							)}
						</div>
						{step === 1 && (
							<Button
								text="Next"
								disabled={noOfPersona === 0}
								submit={() => handleNext()}
							/>
						)}
						{step === 2 && !manualForm && (
							<Button
								text="Submit"
								form="update-enrolment-form"
								loading={loadingButton}
								full
							/>
						)}
						{step === 2 && manualForm && (
							<Button
								text="Submit"
								form="update-enrolment-form"
								loading={loadingButton}
								disabled={(!checkProperties(state) || !startDate)}
								full
							/>
						)}
					</div>
				</div>
			</div>

			<CompanyExists
				setMessage={setErrorMessage}
				message={errorMessage}
			/>

			<PersonaInfoModal
				visible={visiblePersonaInfo}
				hide={hidePersonaInfo}
				show={showPersonaInfo}
				persona={persona}
			/>

			<Modal visible={visibleMyInfoBusiness} variant="medium" close={closeMyInfoBusiness}>
				<CardConfigure>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="my-info__modal__header__close">
								<IconClose
									className="myinfo__fill-form__cursor"
									onClick={() => closeMyInfoBusiness()}
								/>
							</div>
							<div className="my-info__modal">
								<IconInfoBusiness />
								<div className="my-info__modal__content_text">
									Pre-fill the enrolment form quickly with
									Myinfo business.
								</div>
								<div className="my-info__modal__top-margin">
									<Button
										text="Get Started"
										className="my-info__modal__get-started"
										loading={loadingButton}
										full
										maxWidth="140"
										submit={() => getStartedMyInfo()}
									/>
								</div>
								<div className="my-info__modal__manually-selected">
									<span
										className="myinfo__fill-form__cursor"
										onClick={() => closeMyInfoBusiness()}
									>
										Or fill form in manually
									</span>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
				</CardConfigure>
			</Modal>

			<Modal visible={visibleMyInfoErrorBusiness} variant="medium" close={closeMyInfoBusiness}>
				<CardConfigure>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="my-info__modal__header__close">
								<IconClose
									className="myinfo__fill-form__cursor"
									onClick={() => closeMyInfoBusiness()}
								/>
							</div>
							<div className="my-info__modal">
								<div>
									<IconErrorInfoBusiness />
								</div>
								<div className="my-info__modal__top-margin">
									<IconInfoBusiness />
								</div>
								<div className="my-info__modal__content_text">
									We ran into an error connecting with MyInfo
									business. Please try again,
								</div>
								<div className="my-info__modal__top-margin">
									<Button
										text="Try Again"
										className="my-info__modal__get-started"
										submit={() => tryAgainMyInfo()}
									/>
								</div>
								<div className="my-info__modal__manually-selected">
									<span
										className="myinfo__fill-form__cursor"
										onClick={() => closeMyInfoBusiness()}
									>
										Or fill form in manually
									</span>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
				</CardConfigure>
			</Modal>

			<Modal visible={visibleConnectingMyInfoBusiness} variant="small" dismissClickOutsideModal={false}>
				<CardConfigure
					style={{
						maxWidth: rem(312),
						position: "relative",
						borderRadius: "15px",
						backgroundColor: "#F6F7F9",
						boxShadow: "0px 2px 49px rgba(0, 0, 0, 0.205583)",
					}}
				>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="my-info__connecting-modal">
								<div className="">
									<img
										src={GIFLoader}
										alt="loading..."
										width="120px"
									/>
								</div>
								<div className="my-info__modal__error-text my-info__modal__text-font">
									You are being redirected to Myinfo business
								</div>
								<div className="my-info__modal__error-text my-info__modal__closing-top__margin">
									Closing in{" "}
									<span className="my-info-time-left">
										{timeLeft} Sec
									</span>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
				</CardConfigure>
			</Modal>

			<Modal visible={visibleAppointmentSelection} variant="medium" close={hideAppointmentSelection}>
				<CardConfigure>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="select_appointment_header">
								<div className="select_appointment__modal__header__header">
									Select Appointment
								</div>
								<div className="my-info__modal__header__close">
									<IconClose
										className="myinfo__fill-form__cursor"
										onClick={() => hideAppointmentSelection()}
										data-testid="enroll-info-detail-cancel"
									/>
								</div>
							</div>
							<div className="appointment__modal__content_text">
								We found multiple appointments for Company Name. Please select which one to display:
							</div>

							<div className="appointment-modal_height">
								<AppointmentRadio />
							</div>

						</CardConfigure.Body.Col>
					</CardConfigure.Body>

					<CardConfigure.Footer>
						<CardConfigure.Footer.Right data-testid="enroll-info-detail-submit">
							<Button text="Confirm"
								submit={() => fillMyInfoDetailsAppointment()}
								disabled={appointmentIdSelected === ''}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>

				</CardConfigure>
			</Modal>

			<AgentPrincipalInformationModal
				visible={enrolInfoModal}
				hide={hideEnrolInfoModal}
				show={showEnrolInfoModal} />

			<AgentPrincipalTnCModal
				visible={enrolTncModal}
				hide={hideEnrolTnCModal}
				show={showEnrolTncModal}
				acceptParticipantTnc={acceptEnrolTnCModal} />

			<Toast toastList={toastList} />

			{
				loading && (
					ReactDOM.createPortal(
						<div className='modal white'>
							<div className='loading'>
								<img src={assetUrl("/img/loading.gif")} />
							</div>
						</div>
						, document.body
					)
				)
			}

		</>
	);
};

export default AddEnrollPage;
